// extracted by mini-css-extract-plugin
export default {"sortIcon":"SortIcon_sortIcon__Li3wn","arrowIcon":"SortIcon_arrowIcon__SqN-4","arrowDown":"SortIcon_arrowDown__xmFlN","activeOrder":"SortIcon_activeOrder__QT1IC"};